var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodItemCarouselBackButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-left",
    transform: "translate(32 32) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    d: "M15649.439-6280.394a1.37,1.37,0,0,1-.393-.958,1.368,1.368,0,0,1,.393-.957l4.693-4.693-4.693-4.69a1.359,1.359,0,0,1-.393-.953,1.359,1.359,0,0,1,.393-.957,1.351,1.351,0,0,1,1.916,0l5.646,5.643a1.35,1.35,0,0,1,.4.957,1.339,1.339,0,0,1-.4.958l-5.646,5.65a1.356,1.356,0,0,1-.959.393A1.351,1.351,0,0,1,15649.439-6280.394Z",
    transform: "translate(-15637.223 6303.001)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodItemCarouselBackButton);
export default __webpack_public_path__ + "static/media/FoodItemCarouselBackButton.fd1174242e20f032859f2846b760b2cd.svg";
export { ForwardRef as ReactComponent };